import {
    Object3D,
    Vector3,
    AxesHelper,
    Euler
} from 'three';
import {Telescope} from './Telescope'
import {Dome} from './Dome'
import {Building} from './Building'
import bidello,{ component } from 'bidello';
import * as THREE from 'three';
import TWEEN from 'three/examples/jsm/libs/tween.module.min';
import {getSizeBox,getCenter} from '../utils/bounding';
import camera from "../camera"
import {States,stateManager} from "../../services/StateManager";
import {applyRotation} from "../utils/ObjectRotation";
import {viewport} from "../bidello";

export class Observatory extends component(Object3D) {
    init() {

        this.name = States.observatory.DEFAULT_SATE
        stateManager.registerView (this,this.name);
        this.isMounted = false;
        this.glslMesh = null;
        this.allowRevertState = false;
        this.viewGroup = new Object3D();
        this.viewGroupOriginalPosition = new Vector3();
        this.telescope = new Telescope();
        this.dome = new Dome();
        this.building = new Building();

        this.globalPoi = new Vector3();
        this.viewPositionOffsetBuilding = new Vector3();

        this.domePoi = new Vector3();
        this.viewPositionOffsetDome = new Vector3();

        this.telescopePoi = new Vector3();
        this.viewPositionOffsetTelescope = new Vector3();

        this.domeCameraPos = new Vector3();
        this.domeCameraTarget = new Vector3();
        this.buildingCameraPos = new Vector3();
        this.buildingCameraTarget = new Vector3();
        this.telescopeCameraPos = new Vector3();
        this.telescopeCameraTarget = new Vector3();

        this.rotationTarget = this.viewGroup;
        this.originalRotation = new Euler();
        this.originalRotation.set(0,1,0)
        this.allowRotation = false;

        this.defaultStateTween = new TWEEN.Tween(this.viewGroup.position)
            .easing(TWEEN.Easing.Exponential.InOut);

        this.mountTween = new TWEEN.Tween(this.viewGroup.position)
            .easing(TWEEN.Easing.Quadratic.InOut);

        this.unmountTween = new TWEEN.Tween(this.viewGroup.position)
            .easing(TWEEN.Easing.Quadratic.InOut);

        this.rotationTween = new TWEEN.Tween(this.rotationTarget.rotation)
            .easing(TWEEN.Easing.Quadratic.InOut);

        this.viewGroup.add(this.building);
        this.viewGroup.add(this.dome)
        this.viewGroup.add(this.telescope)



    }

    setMesh (glslMesh){

        this.glslMesh = glslMesh;
        const size = (camera.calculateUnitSize().height/2) / getSizeBox(this.glslMesh).y;

        this.glslMesh.children.map((mesh)=>{

            if (mesh.name == "dome_front")this.dome.attachFrontMesh(mesh);
            if (mesh.name == "dome_back")this.dome.attachBackMesh(mesh);
            if (mesh.name == "building")this.building.attachMesh(mesh);
            if (mesh.name == "telescope") this.telescope.attachMesh(mesh);
            if (mesh.name == "global_poi")this.globalPoi = new Vector3().copy(mesh.position);
            if (mesh.name == "dome_poi")this.domePoi = new Vector3().copy(mesh.position);
            if (mesh.name == "telescope_poi")this.telescopePoi = new Vector3().copy(mesh.position);

        })

        this.globalPoi.setY(150)
        this.buildingCameraPos = camera.getCameraPosWithDistanceToSelection([this.building,this.dome],0.7,this.globalPoi);
        this.buildingCameraTarget = getCenter(this.building);
        if (!viewport.isVertical)this.viewPositionOffsetBuilding.setX(camera.calculateUnitSize(this.buildingCameraPos.distanceTo(this.buildingCameraTarget)).width*-0.2);
        if (!viewport.isVertical)this.viewPositionOffsetBuilding.setY(camera.calculateUnitSize(this.buildingCameraPos.distanceTo(this.buildingCameraTarget)).height*0.2);

        this.domeCameraPos = camera.getCameraPosWithDistanceToSelection([this.dome],0.5,this.domePoi);
        this.domeCameraTarget = this.dome.getCenter();
        if (!viewport.isVertical)this.viewPositionOffsetDome.setX(camera.calculateUnitSize(this.domeCameraPos.distanceTo(this.domeCameraTarget)).width*-0.20);
        if (!viewport.isVertical)this.viewPositionOffsetDome.setY(camera.calculateUnitSize(this.domeCameraPos.distanceTo(this.domeCameraTarget)).height*0.15);

        this.telescopeCameraPos = camera.getCameraPosWithDistanceToSelection([this.telescope],0.7,this.telescopePoi);
        this.telescopeCameraTarget = getCenter(this.telescope);
        if (!viewport.isVertical)this.viewPositionOffsetTelescope.setX(camera.calculateUnitSize(this.telescopeCameraPos.distanceTo(this.telescopeCameraTarget)).width*-0.20);


    }

    onStateChange(state){

        if (!this.isMounted)return;
        if (state.state == States.observatory.DEFAULT_SATE ) this.setDefaultState ()
        if (state.state == States.observatory.DOME_STATE)this.setDomeState();
        if (state.state == States.contentDrawer.CLOSE_STATE && this.allowRevertState)this.setDomeState();
        if (state.state == States.observatory.TELESCOPE_STATE)this.setTelescopeState();

    }

    mountView (state){

        this.rotationTarget = this.viewGroup;
        this.allowRotation = true;

        camera.controls.enabled = false;
        camera.position.copy(this.buildingCameraPos);
        camera.controls.target.copy(this.buildingCameraTarget)
        camera.controls.update();
        this.viewGroup.position.copy(this.viewPositionOffsetBuilding)
        this.viewGroup.rotation.copy(this.originalRotation);

        this.isMounted = true;
        this.add(this.viewGroup)
        this.setMountState().onComplete(()=>{
            window.app.viewNavigation.show();
            if (state)state.dispatch();

        })

    }

    unmountView (){

        this.isMounted = false;
        window.app.viewNavigation.hide();
        this.remove(this.viewGroup);

    }

    setDefaultState (){

        this.allowRevertState = false;
        stateManager.addBodyState(States.viewNavigation.DEFAULT);
        this.telescope.setDefaultState();
        this.rotationTarget = this.viewGroup;
        this.allowRotation = true;

        this.building.fadeIn(700);
        this.building.restore();
        this.dome.fadeIn(700);
        this.dome.closeDome();

        camera.tweenCameraPosition(this.buildingCameraPos,700);
        camera.tweenLookAtPosition(this.buildingCameraTarget,700);
        this.rotationTween.to({y:this.originalRotation.y},700).start();
        this.defaultStateTween.to({x:this.viewPositionOffsetBuilding.x,y:this.viewPositionOffsetBuilding.y},700).start();
        this.showUi();
    }


    setDomeState (){

        this.allowRevertState = false;
        this.allowRotation = false;

        this.dome.fadeIn(700);
        this.dome.openDome();
        this.building.fadeOut(700);
        this.building.dropDown();

        camera.tweenCameraPosition(this.domePoi)
        camera.tweenLookAtPosition(this.domeCameraTarget);

        this.rotationTween.to({y:0},700).start();
        this.defaultStateTween.to({x:this.viewPositionOffsetDome.x,y:0},700).start();
        this.showUi()

    }

    setTelescopeState (){


        this.allowRotation = true;
        this.rotationTarget = this.telescope;
        this.dome.fadeOut(700);
        this.building.fadeOut(700);
        this.building.dropDown();
        this.defaultStateTween.to({x:this.viewPositionOffsetTelescope.x,y:0},700).start();
        camera.tweenCameraPosition(this.telescopeCameraPos);
        camera.tweenLookAtPosition(this.telescopeCameraTarget)
        if (viewport.isVertical)this.clearUi();
        this.allowRevertState = true;


    }


    onPointerDrag (data){

        if(!this.allowRotation)return;
        applyRotation(this.rotationTarget,data.pointer.distanceOnDrag,1,0 )


    }

    setUnmountState (){

        this.mountTween.to({y:-10},700).start();

    }

    setMountState (){

        this.viewGroup.position.setY(-10)
        return this.unmountTween.to({y:this.viewPositionOffsetBuilding.y},700).start();

    }

    clearUi (){

        stateManager.removeBodyState("with-main-header");
        stateManager.removeBodyState("view_navigation");


    }

    showUi (){

        stateManager.addBodyState("with-main-header");
        stateManager.addBodyState("view_navigation");

    }



}